// services/companies.ts
import { AuthFetch } from "../hooks/useApi";
import {
  Company,
  CompanyCreatePayload,
  CompanyUpdatePayload,
  DoctorCompaniesResponse,
  DoctorCompanyLinkPayload,
} from "../types/company.types";

export const companyService = {

  create: (
    apiFetch: AuthFetch,
    payload: CompanyCreatePayload,
  ): Promise<Company> =>
    apiFetch<Company>(`/empresas/`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),

  search: (
    apiFetch: AuthFetch,
    query: string,
  ): Promise<Company[]> =>
    apiFetch<Company[]>(`/empresas/search?q=${encodeURIComponent(query)}`, {
      method: "GET",
    }),

  list: (
    apiFetch: AuthFetch,
  ): Promise<Company[]> =>
    apiFetch<Company[]>(`/empresas/`, {
      method: "GET",
    }),

  get: (
    apiFetch: AuthFetch,
    id: number,
  ): Promise<Company> =>
    apiFetch<Company>(`/empresas/${id}`, {
      method: "GET",
    }),

  update: (
    apiFetch: AuthFetch,
    id: number,
    payload: CompanyUpdatePayload,
  ): Promise<Company> =>
    apiFetch<Company>(`/empresas/${id}`, {
      method: "PUT",
      body:   JSON.stringify(payload),
    }),

  remove: (
    apiFetch: AuthFetch,
    id: number,
  ): Promise<void> =>
    apiFetch<void>(`/empresas/${id}`, {
      method: "DELETE",
    }),

  listForDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
  ): Promise<DoctorCompaniesResponse> =>
    apiFetch<DoctorCompaniesResponse>(`/doctors/${doctorEmail}/empresas`, {
      method: "GET",
    }),

  linkToDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    payload: DoctorCompanyLinkPayload,
  ): Promise<void> =>
    apiFetch<void>(`/doctors/${doctorEmail}/empresas`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),

  unlinkFromDoctor: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    companyId: number,
  ): Promise<void> =>
    apiFetch<void>(`/doctors/${doctorEmail}/empresas/${companyId}`, {
      method: "DELETE",
    }),
};
